//生产与测试环境路由配置
// export const rootUrl='https://storedev.jl1.cn' //测试环境
export const rootUrl=window.location.origin

// 渠道落地配置：URL 中 agentCompany 的值 → 需要一并写入 localStorage 的参数名
// 新渠道在此加一行，如 XXX: ["agent", "plan"],
export const CHANNEL_PARAMS = {
  SJZ: ["agent"],
  XZ: ["agent"],
  e2d72f81: ["agent"],
};
